<template>
  <section id="section__signup" class="view-container" v-if="terms">
    <v-row no-gutters>
      <v-col cols="12" class="text-center">
        <v-row no-gutters class="mt-2">
          <v-col cols="12" class="d-flex align-center px-0 justify-center">
            <p class="font--m-1 mt-10 mb-5">회원가입</p>
          </v-col>
        </v-row>
        <v-card elevation="0" class="px-0 my-5">
          <v-card-text class="pa-0">
            <keep-alive>
              <v-row no-gutters>
                <v-col cols="12">
                  <div id="agree-all-terms" class="basic-checkbox" @click="agreeAll()">
                    <input type="checkbox" :checked="isAgreeAll" />
                    <label class="checkmark mr-2"></label>
                    <label class="font--m-4"> 아래 내용에 모두 동의합니다. </label>
                  </div>

                  <HrSolid :classes="['my-2']" />

                  <v-row no-gutters class="pl-1">
                    <v-col
                      cols="12"
                      v-for="(rqt, index) in requiredTerms"
                      :key="rqt.uuid"
                      class="mb-2"
                    >
                      <BasicCheckbox :checked.sync="rqt.isAgree" :name="`required_${index}`">
                        <span> {{ rqt.title }} 동의 (필수)</span>
                        <router-link
                          id="btn__iYiXYhbkkk+90nt/Lv3gyg=="
                          style="text-decoration: none; color: $main-color-default"
                          :to="{ path: `/terms/${rqt.uuid}` }"
                          target="_blank"
                        >
                          보기 >
                        </router-link>
                      </BasicCheckbox>
                    </v-col>

                    <v-col
                      cols="12"
                      v-for="(opt, index) in optionalTerms"
                      :key="opt.uuid"
                      class="mb-2"
                    >
                      <BasicCheckbox :checked.sync="opt.isAgree" :name="`optional_${index}`">
                        <span>{{ opt.title }} 동의 (선택)</span>
                        <router-link
                          id="btn__TD/V78LK20WRdciX/I6rHw=="
                          style="text-decoration: none; color: $main-color-default"
                          :to="{ path: `/terms/${opt.uuid}` }"
                          target="_blank"
                        >
                          보기 >
                        </router-link>
                      </BasicCheckbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </keep-alive>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="mt-5">
        <BasicButton
          id="btn__UCWXvCZhtUCRCp8L/PRpWQ=="
          color="black"
          :disabled="!isAgreeRequired || isLoading"
          :loading="isLoading"
          @click="clickSignup(agreementList)"
        >
          회원가입
        </BasicButton>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { simpleClone } from '@/util'

export default {
  data() {
    return {
      isLoading: false,
      terms: [],
      check1: false,
      prefilled: null,
    }
  },
  computed: {
    requiredTerms() {
      return this.terms.filter((term) => {
        return term.isRequired === true
      })
    },
    optionalTerms() {
      return this.terms.filter((term) => {
        return term.isRequired !== true
      })
    },
    isAgreeRequired() {
      const required = this.requiredTerms.every((rqt) => {
        return rqt.isAgree === true
      })
      return required
    },
    isAgreeAll() {
      return this.terms.every((term) => {
        return term.isAgree === true
      })
    },
    ...mapState('terms', ['termses']),
    initTermses() {
      if (this.termses.length > 0) {
        this.initIsAgree()
        return true
      }
      return false
    },
    agreementList() {
      return this.terms.map((t) => {
        return {
          term: t.uuid,
          isAgreed: t.isAgree,
        }
      })
    },
  },
  watch: {
    // 없으면 작동안함
    initTermses() {},
  },
  created() {
    this.prefilled = JSON.parse(
      decodeURIComponent(escape(window.atob(this.$route.query.prefilled))),
    )
    console.log(this.prefilled)
  },
  methods: {
    ...mapActions('signup', ['affiliatesSignup']),
    ...mapActions('auth', ['signinSuccess', 'getMe']),
    initIsAgree() {
      const temp = simpleClone(this.termses)

      temp.forEach((term) => {
        term.isAgree = false
      })

      this.terms = temp
    },
    agreeAll() {
      if (this.isAgreeAll === true) {
        this.terms.forEach((term) => {
          term.isAgree = false
        })
      } else {
        this.terms.forEach((term) => {
          term.isAgree = true
        })
      }
    },
    async clickSignup(agreementList) {
      try {
        this.isLoading = true
        this.prefilled.agreementList = agreementList
        const { accessToken, refreshToken } = await this.affiliatesSignup(this.prefilled)
        await this.signinSuccess({
          accessToken,
          refreshToken,
        })

        await this.getMe()

        this.$router.push({ name: 'signup/complete', query: { opt: 1 } })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#agree-all-terms {
  .checkmark {
    width: 24px;
    height: 24px;
  }

  .checkmark:after {
    left: 9px;
    top: 5px;
    width: 7px;
    height: 12px;
  }
}
</style>
